// we assume temperature is always Celsius for now
const UnitTemperature = '°C';

export const confirmNumber = (value: string): string => {
  if (value.match(/^[-,+][0-9]+$/)) {
    return value;
  } else if (value.match(/^[0-9]+$/)) {
    return `+${value}`;
  } else {
    return '';
  }
};

export const getTemperatureUnit = (value: string): string => {
  //remove any space in the string
  value = value.replace(/\s/g, '');
  return confirmNumber(value) ? `${confirmNumber(value)} ${UnitTemperature}` : '';
};
